export class unavailablesHistoryDetail {
    constructor(detailHistoryObj) {
        this.unavailableId       = detailHistoryObj.TypeNotReadyId;
        this.time                = detailHistoryObj.Time;
        this.hour                = detailHistoryObj.Hour;
    }
}